/**
 * ChatStagePane — Rooms Chat as a Stage occupant (Issue 22 path).
 *
 * Origin: excellent/app/_chrome/chat-stage-pane.tsx. The full ChatSurface /
 * Rooms v2 tree was not ported in the Vite rollover; this stub keeps the Stage
 * tab contract (keep-alive, onExhausted) so open-stage kind:chat does not
 * crash the host. The dock remains the live chat surface until Rooms lands.
 */

import { Button } from "@excellent/ui";

export function ChatStagePane({
  active: _active,
  onExhausted,
}: {
  active: boolean;
  onExhausted: () => void;
}) {
  return (
    <div
      className="flex h-full w-full min-h-0 flex-col items-center justify-center gap-3 p-8 text-center"
      data-rooms-surface="v2"
      data-rooms-stage="stage"
      data-rooms-occupant="chat"
    >
      <p className="type-body text-muted-foreground max-w-sm">
        Chat Stage is not available on this host yet. Use the dock bar below to
        search or ask, or close this tab to return to Excellent.
      </p>
      <Button type="button" variant="outline" size="sm" onClick={onExhausted}>
        Close Chat
      </Button>
    </div>
  );
}
